// extracted by mini-css-extract-plugin
module.exports = {"mainWeather":"MainWeather_mainWeather__LUyUW","mainContainer":"MainWeather_mainContainer__12AWD","highlightTitle":"MainWeather_highlightTitle__10C62"};